import React from 'react';
import styled from 'styled-components';

import { BgColorInterface, PaddingInterface } from './config/CommonInterfaces';

const GridHorizontalContainer = styled.div<{bg: string, pl: string, pr: string, pt: string, pb: string, placement: string}>`
  flex-grow: 1;
  flex-shrink: 1;
  background-color: ${({ bg, theme: { colors }}) => colors.general[`${bg}`.toUpperCase()]};
  display: flex;
  flex-flow: column;
  padding-left: ${({ pl, theme: { units } }) => units.spacing[`${pl}`.toUpperCase()]};
  padding-right: ${({ pr, theme: { units } }) => units.spacing[`${pr}`.toUpperCase()]};
  padding-top: ${({ pt, theme: { units } }) => units.spacing[`${pt}`.toUpperCase()]};
  padding-bottom: ${({ pb, theme: { units } }) => units.spacing[`${pb}`.toUpperCase()]};
  justify-content: ${({ placement }) => placement};
`;

interface GridHorizontalProps extends BgColorInterface, PaddingInterface {
  children: any,
  cellPlacement: 'flex-start' | 'flex-end' | 'center' | 'space-around' | 'space-between',
  className: string,
}

function GridHorizontal({
  children, bgColor, paddingLeft,
  paddingRight, paddingTop, paddingBottom,
  cellPlacement, className,
}: GridHorizontalProps) {
  return (
    <GridHorizontalContainer
      bg={bgColor}
      pl={paddingLeft}
      pr={paddingRight}
      pt={paddingTop}
      pb={paddingBottom}
      placement={cellPlacement}
      className={`${ className || '' }`}
    >
      { children }
    </GridHorizontalContainer>
  );
}

export default GridHorizontal;

GridHorizontal.defaultProps = {
  children: null,
  bgColor: 'none',
  paddingLeft: 'none',
  paddingRight: 'none',
  paddingTop: 'micro',
  paddingBottom: 'none',
  placement: 'flex-start'
}
